import { useEffect, useState } from 'react';
import {
    Container,
    Grid,
    Typography,
    Box,
    useTheme,
    Paper,
    ToggleButtonGroup,
    ToggleButton,
    Fade,
    Tooltip,
    Button
} from '@mui/material';
import { RefreshCw } from 'lucide-react';
import Templete from '../../template/Template';
import SimpleBackdrop from '../../components/Loading/SimpleBackdrop';
import { AlertInfo } from '../../components/Alerts/Alert';
import { api } from '../../services/api';

import LicenseStatusCard from './LicenseStatusCard';
import ContractDatesCard from './ContractDatesCard';
import { Link } from 'react-router-dom';

const LicenseDashboard = () => {
    const theme = useTheme();
    const [openLoad, setOpenLoad] = useState(false);
    const [selectedLicense, setSelectedLicense] = useState<'active' | 'expiring' | 'expired'>('active');
    const [inicio_licence, setInicioLicence] = useState<Date | null>(null);
    const [final_licence, setFinalLicence] = useState<Date | null>(null);
    const [chave_licence, setChaveLicence] = useState("");
    const [nome_plano_licence, setNomePlanoLicence] = useState("");

    async function loadData() {
        setOpenLoad(true);
        try {
            const response = await api.get('/licence');
            console.log(response)
            if (response && response.data) {
                if (response.data.error) return AlertInfo({ icon: 'error', title: response.data.msg });
                setSelectedLicense(response.data.licence_status);
                setInicioLicence(response.data.inicio_licence);
                setFinalLicence(response.data.final_licence);
                setChaveLicence(response.data.chave_licence);
                setNomePlanoLicence(response.data.nome_plano_licence);

            }
        } catch (error) {
            console.log(error)
            AlertInfo({ icon: 'error', title: 'Falha na conexão' })
        }
        setOpenLoad(false);
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <Templete menuActive="license">
            <SimpleBackdrop open={openLoad} />
            <Container maxWidth="lg" sx={{ py: 4 }}>
                <Box sx={{ mb: 4, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' } }}>
                    <Typography
                        variant="h4"
                        component="h1"
                        sx={{
                            fontWeight: 600,
                            mb: { xs: 2, sm: 0 },
                            color: theme.palette.primary.main,
                            position: 'relative',
                            '&::after': {
                                content: '""',
                                position: 'absolute',
                                bottom: -8,
                                left: 0,
                                width: 60,
                                height: 4,
                                borderRadius: 2,
                                backgroundColor: theme.palette.primary.main
                            }
                        }}
                    >
                        Licença de Uso SysproJud
                    </Typography>

                    <Paper elevation={0} sx={{ p: 0.5 }}>
                        <ToggleButtonGroup
                            value={selectedLicense}
                            exclusive
                            // onChange={handleLicenseChange}
                            aria-label="license status filter"
                            size="small"
                        >
                            <ToggleButton value="active" aria-label="active license">
                                <Tooltip title="Active License">
                                    <Box sx={{ px: 1 }}>Atual</Box>
                                </Tooltip>
                            </ToggleButton>
                            <ToggleButton value="expiring" aria-label="expiring license">
                                <Tooltip title="Expiring Soon">
                                    <Box sx={{ px: 1 }}>Anteriores</Box>
                                </Tooltip>
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Paper>
                </Box>

                <Fade in={true} timeout={800}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <LicenseStatusCard
                                licenseStatus={selectedLicense}
                                inicio_licence={inicio_licence}
                                final_licence={final_licence}
                                chave_licence={chave_licence}
                                nome_plano_licence={nome_plano_licence}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <ContractDatesCard
                                inicio_licence={inicio_licence}
                                final_licence={final_licence}
                                licenseStatus={selectedLicense}
                            />
                        </Grid>
                        <Grid item xs={false} sm={4}></Grid>
                        <Grid item xs={12} sm={4}>
                            <Link to="/planocontrato">
                                <Button
                                    variant="contained"
                                    size="large"
                                    startIcon={<RefreshCw />}
                                    color='success'
                                    fullWidth
                                >
                                    Renovar agora
                                </Button>
                            </Link>
                        </Grid>
                        <Grid item xs={false} sm={4}></Grid>
                    </Grid>
                </Fade>
            </Container>
        </Templete>
    );
};

export default LicenseDashboard;